import { useState } from 'react'

import { Button, Input, message, Modal, Trans } from '@/components'

import boxApi from './api'
import { IFile, validFileName } from './fs'

interface IProps {
  dir: string
  files?: IFile[]
  domain: number
  onOk?: () => void
  disabled?: boolean
}

export default function CreateFolder({ dir, files, domain, onOk, disabled = false }: IProps) {
  const [visible, setVisible] = useState(false)
  const [folderName, setFolderName] = useState('')
  const [loading, setLoading] = useState(false)

  const isNameOK = (name: string) => {
    if (files?.some((it: any) => it.name == name) || !validFileName(name)) {
      return false
    }
    return true
  }

  const onConfirmClick = async () => {
    setLoading(true)
    try {
      const { code } = await boxApi.post('/vol', undefined, {
        params: { path: `${dir}${folderName}/` },
        noErrMsg: false,
        errMsg: 'Failed to create folder.',
        domain,
      })

      if (code === 0) {
        message.success('Folder created successfully.')
        setVisible(false)
        setFolderName('')
        onOk?.()
      }
    } catch (error) {
      //
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Button onClick={() => setVisible(true)} disabled={disabled}>
        <Trans i18nKey="data.newFolderBtn">New Folder</Trans>
      </Button>
      <Modal open={visible} onClose={() => setVisible(false)}>
        <Modal.Header>New Folder</Modal.Header>
        <Modal.Body>
          <Input
            placeholder="Folder Name"
            value={folderName}
            maxLength={30}
            disabled={loading}
            onChange={(e) => setFolderName(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button type="outline" onClick={() => setVisible(false)}>
            <Trans i18nKey="common.confirmModalCancel">Cancel</Trans>
          </Button>
          <Button
            type="secondary"
            onClick={onConfirmClick}
            disabled={!isNameOK(folderName) || loading}
          >
            <Trans i18nKey="common.confirmModalOk">Confirm</Trans>
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
